<template>
  <b-card-body>
    <div>
      <div>
        <small class="dep-leg w-50">Destinatie:</small>
        <span class="tripInfo w-50">{{ params.resortName }}</span>
      </div>
      <div v-if="params.duration">
        <small class="dep-leg w-50">Nopti:</small>
        <span class="tripInfo w-50">{{ params.duration }}</span>
      </div>
      <div v-if="params.checkIn">
        <small class="dep-leg w-50">Check in:</small>
        <span class="tripInfo w-50">{{ params.checkIn }}</span>
      </div>
      <div v-if="params.checkOut">
        <small class="dep-leg w-50">Check out:</small>
        <span class="tripInfo w-50">{{ params.checkOut }}</span>
      </div>
    </div>
  </b-card-body>
</template>

<script>
export default {
  name: 'CarInfo',
  props: ['params']
}
</script>

<style lang="scss" scoped>

</style>
